import { Controller } from '@hotwired/stimulus'

export default class Faq extends Controller {
  toggle(event) {
    const item = event.currentTarget.closest('.faq__item') || event.currentTarget.closest('.faq-list__item')
    if (item) {
      item.classList.toggle('is-open')
      item.classList.toggle('open')
    }
  }
}
